export default {
    addonsTitle: 'Add-ons',
    addonsMenu: 'Add-ons',
    newAddon: 'Nuevo add-on',
    editAddon: 'Editar add-on',
    createAddon: 'Crear add-on',
    addonName: 'Nombre del add-on',
    addonModule: 'Módulo',
    addonAttribute: 'Atributo ampliable',
    addonUnitValue: 'Incremento por unidad',
    addonPricePerUnit: 'Precio por unidad',
    addonCurrency: 'Moneda',
    addonActive: 'Activo',
    addonNameEs: 'Nombre (Español)',
    addonNameEn: 'Nombre (English)',
    selectModule: 'Selecciona un módulo',
    selectAttribute: 'Selecciona un atributo',
    noEligibleAttributes: 'Este módulo no tiene atributos ampliables con add-ons',
    addonCreated: 'Add-on creado exitosamente',
    addonUpdated: 'Add-on actualizado exitosamente',
    addonStatusUpdated: 'Estado del add-on actualizado',
    addonCreateError: 'Error al crear el add-on',
    addonUpdateError: 'Error al actualizar el add-on',
    addonLoadError: 'Error al cargar los add-ons',
    addonStatusError: 'Error al cambiar el estado del add-on',
    confirmToggleAddon: '¿Deseas cambiar el estado de este add-on?',
    confirmDeleteAddon: '¿Está seguro que desea eliminar este add-on? Esta acción no se puede deshacer.',
    addonDeleted: 'Add-on eliminado exitosamente',
    addonDeleteError: 'Error al eliminar el add-on',
    attributeImmutableHint: 'El atributo no puede cambiarse después de crear el add-on',
    tableId: 'ID',
    tableStatus: 'Estado',
    tableActions: 'Acciones',
    statusActive: 'Activo',
    statusInactive: 'Inactivo',
    backToList: 'Volver',
    save: 'Guardar',
    cancel: 'Cancelar',
    enableEdit: 'Habilitar edición',
    enableEditFirst: 'Es necesario habilitar la edición',
    validationNameEsRequired: 'El nombre en español es obligatorio',
    validationNameEnRequired: 'El nombre en inglés es obligatorio',
    validationUnitValueRequired: 'El incremento es obligatorio',
    validationUnitValueNumber: 'El incremento debe ser un número',
    validationUnitValueMin: 'El incremento debe ser al menos 1',
    validationPriceRequired: 'El precio es obligatorio',
    validationPriceNumber: 'El precio debe ser un número',
    validationPriceMin: 'El precio no puede ser negativo',
    validationCurrencyRequired: 'La moneda es obligatoria',
};
